import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useLayoutEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { $windowSize } from 'ziphy-web-shared/basic/utils/windowSize';
import $livequeueChats from '@core/src/store/livequeueChatStore';
import SendIcon from '../../../assets/icons/sendIcon';
import { UploadMessage } from '../../UploadMessage/UploadMessage';
import { useChatActions } from '../hooks/useChatActions';
import { useChatMessages } from '../hooks/useChatMessages';
import { checkCanFillIntake, checkCanUploadResults } from '../utils/checkCanUploadResults';
import MessagesList from './MessagesList/MessagesList';
import styles from './styles.module.scss';
import { $router } from 'ziphy-web-shared/basic/utils/router';
const ChatComponent = ({ chatId, maxHeight, consultation }) => {
    const role = $auth.role.role;
    const roleId = $auth.role.id;
    const isClient = role === 'client';
    const isProvider = role === 'provider';
    const { chatContainerRef, topMessageRef, bottomMessageRef, handleScroll, scrollToBottom } = useChatMessages(chatId);
    const { handleChange, handleKeyDown, handleSend, ResultModal, inputValue, onAttachmentClick, handleShowResultsModal, handleShowUploadModal, handleFillIntake, handleCheckResultsForAttachments, handleAddProviderAttachment, } = useChatActions(chatId, consultation, scrollToBottom);
    useEffect(() => {
        const id = $router.searchParams.get('openLabResults');
        if (id) {
            const attachment = consultation.attachments.find(el => el.id === id);
            if (attachment) {
                onAttachmentClick(attachment);
            }
            $router.searchParams.remove('openLabResults');
        }
    }, [consultation._id]);
    useEffect(() => {
        $livequeueChats.setViewer(role, roleId);
    }, [role, roleId]);
    useEffect(() => {
        return () => {
            $livequeueChats.clearCurrentChatMessages();
        };
    }, [chatId]);
    useLayoutEffect(() => {
        if (!$windowSize.isMobile && $livequeueChats.messagesToScroll.length > 0) {
            const id = $livequeueChats.messagesToScroll[0];
            const message = document.getElementById(id);
            if (message) {
                message.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [$livequeueChats.messagesToScroll.length, $windowSize.isMobile]);
    const showUnreadToast = useMemo(() => {
        return (!$livequeueChats.isScrolledToBottom &&
            !!$livequeueChats.unreadAnchorId &&
            !$livequeueChats.unreadAnchorVisible);
    }, [
        $livequeueChats.isScrolledToBottom,
        $livequeueChats.unreadAnchorId,
        $livequeueChats.unreadAnchorVisible,
    ]);
    const handleScrollToUnread = useCallback(() => {
        const anchorId = $livequeueChats.unreadAnchorId;
        if (!anchorId)
            return;
        const element = document.getElementById(anchorId);
        if (element) {
            element.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
    }, [$livequeueChats.unreadAnchorId]);
    return (_jsxs("div", Object.assign({ className: styles.container, style: { height: maxHeight, transition: 'max-height 200ms ease' } }, { children: [_jsxs("div", Object.assign({ className: styles.chatMessagesWrapper }, { children: [_jsxs("div", Object.assign({ className: styles.chatMessages, ref: chatContainerRef, onScroll: handleScroll }, { children: [_jsx("div", { ref: topMessageRef, style: { height: 1 } }), _jsx("div", { className: styles.fade }), _jsx(MessagesList, { role: role, currentRoleId: roleId, messages: $livequeueChats.currentChatMessages, consultation: consultation, isInitialLoading: $livequeueChats.isInitialLoading, handleCheckResultsForAttachments: handleCheckResultsForAttachments, handleShowResultsModal: handleShowResultsModal, onAttachmentClick: onAttachmentClick, containerRef: chatContainerRef }), _jsx("div", { ref: bottomMessageRef, style: { height: 1 } })] })), showUnreadToast && (_jsx("button", Object.assign({ type: "button", className: styles.newMessagesToast, onClick: handleScrollToUnread }, { children: _jsx(Icon, { type: "chevron" }) })))] })), checkCanUploadResults(isClient, consultation) && (_jsx(UploadMessage, { type: "upload-test-results", onClick: handleShowUploadModal })), checkCanFillIntake(isProvider, consultation) && (_jsx(UploadMessage, { type: "fill-intake", onClick: handleFillIntake })), _jsx(ResultModal, {}), _jsxs("div", Object.assign({ className: cn(styles.chatInput, isClient && styles.chatInputClient, isProvider && styles.chatInputProvider), onKeyDown: handleKeyDown }, { children: [_jsx("input", { autoFocus: true, type: "text", value: inputValue, onChange: handleChange, className: styles.input, placeholder: "Message" }), _jsx("div", Object.assign({ className: styles.inputIconRight, onClick: handleSend }, { children: _jsx(SendIcon, {}) }))] }))] })));
};
export default observer(ChatComponent);
